export const LayerFileType = {
  GeoJSON: "GEOJSON",
  KML: "KML",
  WMS: "WMS",
};
